var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.7424 0.256009C13.401 -0.0853364 12.8536 -0.0853364 12.5122 0.256009L6.9992 5.76906L1.48614 0.256009C1.1448 -0.0853364 0.597355 -0.0853364 0.256009 0.256009C-0.0853364 0.597355 -0.0853364 1.1448 0.256009 1.48614L5.76906 6.9992L0.256009 12.5122C-0.0853364 12.8536 -0.0853364 13.401 0.256009 13.7424C0.423462 13.9098 0.648879 14 0.867855 14C1.08683 14 1.31225 13.9163 1.4797 13.7424L6.99275 8.22933L12.5058 13.7424C12.6733 13.9098 12.8987 14 13.1177 14C13.3431 14 13.562 13.9163 13.7295 13.7424C14.0708 13.401 14.0708 12.8536 13.7295 12.5122L8.22933 6.9992L13.7424 1.48614C14.0837 1.1448 14.0837 0.597355 13.7424 0.256009Z",
    fill: "#CDCFD0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.4d6e9ce4.svg";
export { ForwardRef as ReactComponent };